// Standard chart palette — single source of truth for physio_admin's D3 charts.
//
// Mirrors the "Proposed shared palette" in docs/CHART_COLOR_AUDIT.html. The
// agreed standard is the patient-app TracPatch session palette
// (physio_app_web/styles/tracpatch-exercise.css) — keep these in sync with it.
// Import from here instead of hardcoding hexes so colours can't drift again.
export const CHART_COLORS = {
  lineBlue: '#1890ff', // primary line & bar: pain, flexion, steps, cadence, OKS, femur temp, dashboard bars
  secondaryRed: '#f5222d', // second dataset line: extension, tibia temp
  completeGreen: '#2e7d32', // complete / over-achieved / activity all-complete
  completeGreenSoft: '#57B894', // pie "completed"
  partialYellow: '#FFCE70', // partially done
  skippedRed: '#F86D70', // pie "skipped"
  remainingGray: '#dddddd', // pie "remaining"
  cardBorderOrange: '#f5881f', // card borders / progress indicator
  navy: '#012448', // navy buttons / text
  rangeGreen: '#C8E6C9', // light-green range bands
}

export default CHART_COLORS
